import React, { createContext, useContext, useState, useCallback, useEffect, useRef } from "react";
import { DICT } from "./dict";
import { useAuth } from "../context/AuthContext";

const LangCtx = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("lang") || "fr");
  const setLang = (l) => { localStorage.setItem("lang", l); setLangState(l); };
  const toggle = () => setLang(lang === "fr" ? "en" : "fr");
  const t = useCallback((fr) => {
    if (fr == null) return fr;
    return lang === "en" ? (DICT[fr] ?? fr) : fr;
  }, [lang]);
  return <LangCtx.Provider value={{ lang, setLang, toggle, t }}>{children}</LangCtx.Provider>;
}

export const useLang = () => useContext(LangCtx);

// Applies the per-account saved language once after login.
export function LangSync() {
  const { user } = useAuth();
  const { setLang } = useLang();
  const applied = useRef(null);
  useEffect(() => {
    if (user && user.language && applied.current !== user.id) {
      applied.current = user.id;
      setLang(user.language);
    }
  }, [user, setLang]);
  return null;
}
